import * as React from "react";

function SvgCanny(props, ref) {
  return (
    <svg
      id="Canny_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>{".Canny_svg__st1{fill:#fff}"}</style>
      <path fill="#525df9" d="M0 0h100v100H0z" />
      <path
        className="Canny_svg__st1"
        d="M50.2 80.4C38.5 80.4 29 70.9 29 59.1V40.9c0-11.8 9.7-21.3 21.3-21.3 10.5 0 19.3 7.4 20.9 17.7.3 1.6-.8 3.3-2.5 3.4-1.6.3-3.3-.8-3.4-2.5-1.3-7.4-7.5-12.6-14.9-12.6-8.3 0-15.2 6.9-15.2 15.2V59c0 8.3 6.7 15.2 15.2 15.2 7.4 0 13.7-5.2 14.9-12.6.3-1.6 1.8-2.8 3.4-2.5 1.6.3 2.8 1.8 2.5 3.4-1.8 10.5-10.6 17.9-21 17.9z"
      />
      <path
        className="Canny_svg__st1"
        d="M43.4 52.7c-1.6 0-2.9-1.3-2.9-3.1v-8.7c0-5.4 4.4-9.8 9.8-9.8 3.8 0 7 2.1 8.7 5.4.8 1.5.2 3.3-1.3 4.1-1.5.8-3.3.2-4.1-1.3-.7-1.3-2-2.1-3.4-2.1-2.1 0-3.8 1.6-3.8 3.8v8.8c-.1 1.6-1.2 2.9-3 2.9z"
        opacity={0.5}
      />
    </svg>
  );
}

export default React.forwardRef(SvgCanny);
